module.exports = __webpack_public_path__ + "/static/assets/a997e2206a41ff2b09622bdeb439a301.png";